import { render, staticRenderFns } from "./changeStatusList.vue?vue&type=template&id=1a05439a&scoped=true&"
import script from "./changeStatusList.vue?vue&type=script&lang=js&"
export * from "./changeStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05439a",
  null
  
)

export default component.exports